// OVERVIEW-shaped machine_card fixture (ME-MACHINEID-RENDER SP-2 tests).
// One tab per section (arm merged); a mix of POPULATED sections (io_master
// on_target, feeders stale + per-bowl breakdown) and structural PLACEHOLDER tabs
// (arm/unloader/vision/control_safety — figures:[] + verdict.status:"unknown" +
// "Pending — not wired this milestone"). STALE + historical_backfill so the
// two-clock split renders in the overview host too. Placeholders MUST render as
// "Pending", never a fabricated 0/fault; worst verdict across POPULATED sections
// is `stale` (feeders) — neutral outranks the positive io_master on_target.
import type { MachineCardArtifactData } from "../../../chatBot/models/machineEvidenceModels";

export const OVERVIEW_MACHINE_GUID = "d72d27d9-0308-49e6-7c19-08dec02ae617";

const placeholder = (part_slug: string, name: string) => ({
  part_slug,
  name,
  parent_slug: null,
  verdict: {
    status: "unknown" as const,
    headline: "Pending — not wired this milestone",
    detail: null,
    basis: null,
  },
  lane_coverage: {},
  figures: [],
  trend: null,
  live: null,
});

export const OVERVIEW_MACHINE_CARD: MachineCardArtifactData = {
  schema_version: 1,
  mode: "snapshot",
  machine: {
    machine: OVERVIEW_MACHINE_GUID,
    machine_id_full: OVERVIEW_MACHINE_GUID,
    class_template: null,
    display_name: "MASHi2601",
  },
  freshness: {
    state: "STALE",
    as_of: "2026-06-30T16:33:00+00:00",
    last_sample_at: "2026-06-29T18:08:27.134590+00:00",
    age_seconds: 73454,
    source: "mash_liveness",
    provenance: "historical_backfill",
    event_time: "2026-06-10T09:24:53.263000+00:00",
  },
  tabs: [
    {
      part_slug: "io_master",
      name: "Output",
      parent_slug: null,
      verdict: {
        status: "on_target",
        headline: "Output nominal this window",
        detail: null,
        basis: "occurrence count",
      },
      lane_coverage: {},
      figures: [
        {
          id: "f_part",
          label: "Parts produced",
          value: 10386,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 10386,
          source_ref: "s_part",
          freshness: null,
          breakdown: null,
        },
      ],
      trend: null,
      live: null,
    },
    {
      part_slug: "feeders",
      name: "Feeders",
      parent_slug: null,
      verdict: {
        status: "stale",
        headline: "Feeder presentation: 2172 NOK occurrences this window across 4 bowl(s)",
        detail: null,
        basis: "occurrence count (no calibrated threshold this milestone)",
      },
      lane_coverage: {},
      figures: [
        {
          id: "f_feeder_presentation_nok",
          label: "Feeder presentation NOK",
          value: 2172,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 2172,
          source_ref: "s_feeder_presentation_nok",
          freshness: null,
          breakdown: {
            pending: false,
            pending_reason: null,
            group_label: "bowl",
            truncated: null,
            rows: [
              { label: "bowl 2", value: 1936, unit: null, denominator: null, n: 1936 },
              { label: "bowl 4", value: 107, unit: null, denominator: null, n: 107 },
              { label: "bowl 3", value: 66, unit: null, denominator: null, n: 66 },
              { label: "bowl 1", value: 63, unit: null, denominator: null, n: 63 },
            ],
          },
        },
      ],
      trend: null,
      live: null,
    },
    placeholder("arm", "Arm"),
    placeholder("unloader", "Trays / Unloader"),
    placeholder("vision", "Vision"),
    placeholder("control_safety", "Control / Safety"),
  ],
  sources: [
    {
      id: "s_part",
      signal_key: "part",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 10386,
      source_grain: "event",
      read_source: "telemetry store",
      edge_path: null,
    },
    {
      id: "s_feeder_presentation_nok",
      signal_key: "feeder_presentation_nok",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 2172,
      source_grain: "event",
      read_source: "telemetry store",
      edge_path: null,
    },
  ],
  frozen: { is_frozen: false, frozen_at: null },
};
